import { Component, OnDestroy, Renderer2 } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppConfigService } from './app-config/app-config-service';
import { initNumericOnlyGlobalHandlers } from './common-components/numeric-only/numeric-only-global-handler';
import { ThemeService } from './pages/site-layout/themes/theme.service';
import { Themes } from './pages/site-layout/themes/themes.enum';
import { getUseAlternatingRowColors } from './store/user-preferences/user-preferences.selectors';

@Component({
   selector: 'ndt-root',
   styleUrls: ['./app.component.scss'],
   templateUrl: './app.component.html',
   standalone: false,
})
export class AppComponent implements OnDestroy {
   title = 'ndt-client';

   private unsubscribe = new Subject<void>();

   constructor(
      themeService: ThemeService,
      renderer: Renderer2,
      appConfigService: AppConfigService,
      private store: Store
   ) {
      themeService.currentTheme$.pipe(takeUntil(this.unsubscribe)).subscribe(([currentTheme, newTheme]) => {
         const currentThemeStr = Themes[currentTheme].toLowerCase();
         const newThemeStr = Themes[newTheme].toLowerCase();
         renderer.removeClass(document.body, `theme-${currentThemeStr}`);
         renderer.addClass(document.body, `theme-${newThemeStr}`);
      });
      const adminToken = appConfigService.getConfig()?.adminToken;
      themeService.setTheme(adminToken ? Themes.Default : Themes.Customer);
      this.store.pipe(select(getUseAlternatingRowColors), takeUntil(this.unsubscribe)).subscribe((useAlternating) => {
         document.body.classList.toggle('table-striped', !!useAlternating);
      });

      // Applies digit-only input, paste sanitization, and scroll-to-change
      // prevention to every input[type="number"] app-wide. See
      // numeric-only-global-handler.ts for why this isn't an Angular directive.
      initNumericOnlyGlobalHandlers();
   }

   ngOnDestroy(): void {
      this.unsubscribe.next();
   }
}
